import { ILockBreakTimeItem } from 'features/appointment/services/types/lockBreakTime';
import { momentTimezone } from 'utils/time';

export type IStaffWorkingHours = {
  startTime: string; // 'HH:mm'
  endTime: string; // 'HH:mm'
};

/**
 * Trả về Set staffId nghỉ "cả ngày".
 *
 * Một staff được coi là nghỉ cả ngày khi có ÍT NHẤT MỘT block hour đơn lẻ phủ
 * kín giờ làm việc của chính họ (`timeSchedule.startTime` → `endTime`), bất kể
 * block đó là type 'OFF' hay 'BLOCK'. Tiêu chí dựa trên KHOẢNG THỜI GIAN phủ
 * kín, không dựa vào field type.
 *
 * - Break ('BREAK') không tính.
 * - Không gộp nhiều block nhỏ — chỉ xét từng block đơn.
 * - Staff không có giờ làm việc (timeSchedule rỗng) → không xác định được → bỏ qua.
 */
export const getFullDayOffStaffIds = (
  lockBreakTimes: ILockBreakTimeItem[],
  workingHoursByStaff: Map<string, IStaffWorkingHours>
): Set<string> => {
  const set = new Set<string>();

  lockBreakTimes.forEach((item) => {
    if (!item.staffId || item.type === 'BREAK') return;
    if (set.has(item.staffId)) return;

    const work = workingHoursByStaff.get(item.staffId);
    if (!work?.startTime || !work?.endTime) return;

    const blockStart = momentTimezone(item.startTime);
    const blockEnd = momentTimezone(item.endTime);
    if (!blockStart.isValid() || !blockEnd.isValid()) return;

    // Dựng mốc giờ làm việc trên cùng ngày với block để so sánh thời điểm.
    const [ws, wsm] = work.startTime.split(':');
    const [we, wem] = work.endTime.split(':');
    const workStart = blockStart
      .clone()
      .set({ hour: Number(ws), minute: Number(wsm) || 0, second: 0, millisecond: 0 });
    const workEnd = blockStart
      .clone()
      .set({ hour: Number(we), minute: Number(wem) || 0, second: 0, millisecond: 0 });

    if (blockStart.isSameOrBefore(workStart) && blockEnd.isSameOrAfter(workEnd)) {
      set.add(item.staffId);
    }
  });

  return set;
};

export default getFullDayOffStaffIds;
